/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import dayjs from "dayjs";
import styled from "styled-components";
import { Datepicker, DayPicker, Input, theme } from "@nordcloud/gnui";
import { useClickOutside } from "~/tools";

const Wrapper = styled.div`
  position: absolute;
  z-index: ${theme.zindex.popup};
  filter: drop-shadow(0 1.5rem 1.5rem rgba(0, 0, 0, 0.2));
`;

type Props = {
  value: string | null;
  setValue: (value: string) => void;
  close: () => void;
};

function DatePickerField({ value, setValue, close }: Props) {
  const [internalValue, setInternalValue] = React.useState(
    (value || "").substring(0, 10)
  );

  const setValueFromInput = () => {
    const newDate = dayjs(internalValue);
    if (newDate.isValid()) {
      setValue(newDate.format());
    }
    close();
  };

  const wrapperRef = React.useRef(null);
  useClickOutside(wrapperRef, setValueFromInput);

  return (
    <div ref={wrapperRef}>
      <form onSubmit={setValueFromInput}>
        <Input
          type="text"
          small
          defaultValue={internalValue}
          onChange={(ev) => setInternalValue(ev.target.value)}
        />
      </form>

      <Wrapper>
        <Datepicker>
          <DayPicker
            selected={value ? dayjs(value).toDate() : dayjs().toDate()}
            onDayClick={(newD: Date | undefined) => {
              const date = dayjs(newD).format();
              setValue(date);
              close();
            }}
          />
        </Datepicker>
      </Wrapper>
    </div>
  );
}

export { DatePickerField };
